import { cn } from '@/lib/utils';
import budgetIcon from '@/assets/icons/budget-white.svg';
import { getIconComponent } from '@/utils/budgetIcons';

interface BudgetCardProps {
  budget: any;
  isActive?: boolean;
  onClick?: () => void;
}

export const BudgetCard: React.FC<BudgetCardProps> = ({ budget, isActive = false, onClick }) => {
  const IconComponent = getIconComponent(budget?.icon_id);

  return (
    <div
      className={cn(
        'w-full rounded-2xl transition-all duration-300 relative',
        isActive ? 'cursor-pointer' : 'cursor-default'
      )}
      style={{ backgroundColor: budget?.color_hex || '#D9D9D9`' }}
      onClick={onClick}
    >
      <div className="p-[0.65rem] text-white h-full flex flex-col">
        <span className="absolute top-2 right-2 contrast-[0.65]">
          <IconComponent width={80} height={80} strokeColor={budget?.color_hex || '#D9D9D9'} />
        </span>
        <div className="mb-2">
          <img src={budgetIcon} alt="" className="mb-1 h-[20px]" />
          <h3 className="text-[1rem] font-medium leading-[23px]">{budget?.name || '-'}</h3>
          <p className="text-xs my-0 p-0 mb-0 min-h-[35px]">
            {budget?.description && budget.description.length > 60
              ? `${budget.description.substring(0, 30)}...`
              : budget?.description || '-'}
          </p>
        </div>

        <div className="flex items-start justify-between mt-auto">
          <div className="flex-1">
            <p className="opacity-80 text-[10px] leading-[12px]">BTEV</p>
            <p className="font-bold text-xs">{Number(budget?.btev) + Number(budget?.btev_used)}</p>
          </div>
          <div className="flex-1 ml-3">
            <p className="opacity-80 text-[10px] leading-[12px]">BTRT</p>
            <p className="font-bold text-xs">{budget?.btrt}</p>
          </div>
        </div>

        <div className="flex items-start justify-between mt-3">
          <div className="flex-1">
            <p className="font-medium opacity-80 text-[10px] leading-[15px]">Remaining BTEV</p>
            <p className="font-bold text-[1rem]">{budget?.btev}</p>
          </div>
          <div className="flex-1 ml-3">
            <p className="font-medium opacity-80 text-[10px] leading-[15px]">Achieved BTRT</p>
            <p className="font-bold text-[1rem]">{budget?.btrt_achieved}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
